module.exports = __webpack_public_path__ + "static/media/rocket.716a55bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocket.png
// module id = 43
// module chunks = 0